<template>
  <div>
    <modal
      name="team-role-remove"
      :adaptive="true"
      :minHeight="315"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Team - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="removeRole">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="name"
                label="Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="role.name"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="role.description"
              />
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Remove Role"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamIncidentRemove
  Description: This class representing a team incident remove modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom roles state values. 
  */
  data() {
    return {
      roles: [],
    };
  },

  /* 
    Define props from which we got team and role data. 
  */
  props: {
    team: null,
    role: null
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call TeaemService class to remove selected role from the certain team.
    */
    removeRole() {
      var data = { roles: [this.role.id]};

      TeamService.removeRole(this.team.id, data).then(() => {
        location.reload();
      });
    },
  }
};
</script>
